export default {
  'consent:page-hidden:text':
    'Deze pagina is niet volledig zichtbaar omdat je geen toestemming voor functionele cookies hebt gegeven.',
  'consent:page-hidden:button': 'Cookie-instellingen openen',
};
